const setOpen = (item, open) => {
	item.classList.toggle("is-open", open);
	item.querySelector(".accordion-toggle")?.setAttribute("aria-expanded", String(open));
	const panel = item.querySelector(".accordion-panel");
	if (panel) panel.inert = !open;
};

function initAccordions() {
	document.querySelectorAll(".accordion-list").forEach((list) => {
		if (list.dataset.accordionInit) return;
		list.dataset.accordionInit = "true";
		const items = [...list.querySelectorAll(".accordion-item")];

		items.forEach((item) => {
			item.querySelector(".accordion-toggle")?.addEventListener("click", () => {
				const open = !item.classList.contains("is-open");
				items.forEach((other) => other !== item && setOpen(other, false));
				setOpen(item, open);
			});
		});
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initAccordions);
} else {
	initAccordions();
}
